/** @format */

import React from "react";
import TestimonialCarousel from "../Component/TestimonialCarousel";

function Service() {
  return (
    <>
      {/* Page Header Start */}
      <div className="container-fluid page-header py-5 mb-5">
        <div className="container py-5">
          <h1 className="display-3 text-white mb-3 animated slideInDown">
            Services
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a className="text-white" href="#">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <a className="text-white" href="#">
                  Pages
                </a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Services
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* Page Header End */}
      {/* Service Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h6 className="text-primary">Our Services</h6>
            <h1 className="mb-4">
              We Are Pioneers In The World Of Renewable Energy
            </h1>
          </div>
          <div className="row g-4">
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="service-item rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-1.jpg" alt="" />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-solar-panel fa-3x" />
                  </div>
                  <h4 className="mb-3">Solar Energy</h4>
                  <p>
                    Solar energy financing <br />
                    Solar energy monitoring <br />
                    Solar panel installation
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="service-item rounded overflow-hidden">
                <img
                  className="img-fluid"
                  src="img/wind4.jpeg"
                  alt=""
                  style={{ width: 400, height: 280 }}
                />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-wind fa-3x" />
                  </div>
                  <h4 className="mb-3">Wind Energy</h4>
                  <p>
                    Wind Energy Consulting <br />
                    Wind Energy Financing
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="service-item rounded overflow-hidden">
                <img
                  className="img-fluid"
                  src="img/hydropower2.jpeg"
                  alt=""
                  style={{ width: 400, height: 280 }}
                />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-lightbulb fa-3x" />
                  </div>
                  <h4 className="mb-3">Hydropower Plants</h4>
                  <p>
                    Electricity generation <br />
                    Irrigation
                    <br />
                    Recreation
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="service-item rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-4.jpg" alt="" />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-solar-panel fa-3x" />
                  </div>
                  <h4 className="mb-3">Solar Panels</h4>
                  <p>
                    <b>Solar panel installation:</b> Solar panels can be
                    installed on rooftops, in yards, or on commercial buildings.
                    We as providers can help you choose the right solar panel
                    system for your needs and budget, and can handle the entire
                    installation process. <br />
                    <b>Solar panel maintenance:</b> Solar panels require very
                    little maintenance, but it is important to have them
                    inspected and cleaned regularly. We can offer solar panel
                    maintenance plans to ensure that your panels are operating
                    at peak efficiency.
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="service-item rounded overflow-hidden">
                <img
                  className="img-fluid"
                  src="img/wind3.jpeg"
                  alt=""
                  style={{ width: 400, height: 280 }}
                />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-wind fa-3x" />
                  </div>
                  <h4 className="mb-3">Wind Turbines</h4>
                  <p>
                    <b>Wind turbine installation:</b> Wind turbines can be
                    installed on land or offshore. Wind energy services
                    providers can help you choose the right wind turbine system
                    for your needs and budget, and they can handle the entire
                    installation process. <br />
                    <b>Wind turbine maintenance:</b> Wind turbines require
                    regular maintenance to ensure that they are operating safely
                    and efficiently. Wind energy services providers can offer
                    wind turbine maintenance plans to ensure that your turbines
                    are always in good condition.
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="service-item rounded overflow-hidden">
                <img
                  className="img-fluid"
                  src="img/hydropower1.jpeg"
                  alt=""
                  style={{ width: 400, height: 280 }}
                />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-lightbulb fa-3x" />
                  </div>
                  <h4 className="mb-3">Hydropower Plants</h4>
                  <p>
                    Electricity generation: Hydropower is a renewable and
                    sustainable source of electricity that can help to reduce
                    our reliance on fossil fuels. Hydropower plants can generate
                    electricity on demand, making them a reliable source of
                    baseload power. <br />
                    Flood control: Hydropower dams can help to control flooding
                    by storing excess water during heavy rains and releasing it
                    gradually during dry periods. <br />
                    Irrigation: Hydropower dams can provide water for
                    irrigation, which can help to improve agricultural
                    productivity.
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Service End */}
      {/* Feature Start */}
      <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
        <div className="container feature px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div
              className="col-lg-6 feature-text py-5 wow fadeIn"
              data-wow-delay="0.1s"
            >
              <div className="p-lg-5 ps-lg-0">
                <h6 className="text-primary">Why Choose Us!</h6>
                <h1 className="mb-4">
                  Complete Commercial &amp; Residential Solar Systems
                </h1>
                <p className="mb-4 pb-2">
                  Trusted experts in renewable energy, delivering innovative
                  solutions for a sustainable future.
                </p>
                <div className="row g-4">
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-check text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Quality</p>
                        <h5 className="mb-0">Services</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-user-check text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Expert</p>
                        <h5 className="mb-0">Workers</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-drafting-compass text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Free</p>
                        <h5 className="mb-0">Consultation</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-headphones text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Customer</p>
                        <h5 className="mb-0">Support</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 pe-lg-0 wow fadeIn"
              data-wow-delay="0.5s"
              style={{ minHeight: "400px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="position-absolute img-fluid w-100 h-100"
                  src="img/feature.jpg"
                  style={{ objectFit: "cover" }}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Feature End */}
      {/* Testimonial Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h6 className="text-primary">Testimonial</h6>
            <h1 className="mb-4">What Our Clients Say!</h1>
          </div>
          <TestimonialCarousel />
        </div>
      </div>
      {/* Testimonial End */}
    </>
  );
}

export default Service;
